<style lang="scss" type="text/scss">
    .status-tag-container {
        .success-tag, .error-tag {
            display: flex;
            justify-content: center;
            align-items: center;

            .icon {
                font-size: .85rem;
                margin-right: .5rem;
            }
        }
        .error-tag {
            color: #C55;
        }
        .success-tag {
            color: #359179;
        }
    }
</style>

<template>
    <div class="status-tag-container">
        <div class="success-tag" v-if="success">
            <i class="icon">&#xe60e;</i>
            <span>{{ positiveText }}</span>
        </div>
        <div class="error-tag" v-else>
            <i class="icon">&#xe673;</i>
            <span>{{ negativeText }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            success: {
                type: Boolean,
                default: true
            },
            positiveText: {
                type: String,
                default: '已完成'
            },
            negativeText: {
                type: String,
                default: '未完成'
            }
        },
        data () {
            return {};
        }
    };
</script>
